export const MIN_AUTO_CANCEL_DAYS: number = 1
export const MAX_AUTO_CANCEL_DAYS: number = 365
export const DEFAULT_AUTO_CANCEL_DAYS: string = "3"
export const DEFAULT_AUTO_CANCEL: boolean = true
